module.exports = __webpack_public_path__ + "img/map.9aa62c85.png";